import {
  FormSectionStateArray,
  FormState,
  StateField,
  StateFieldType,
} from '@navstation-portal/reporting/data-model/vessel-report';
import { CargoDetailsVm } from '@navstation-portal/reporting/data-model/vessel-report';

export function buildCargoDetailsVm(formState: FormState): CargoDetailsVm {
  const isStowageDetailsValid = () => {
    const stowageDetailsSection = formState['stowageDetails'];
    if (!stowageDetailsSection) return false;

    const cargoesEntry = stowageDetailsSection['numberOfCargoes'] as StateField<StateFieldType>;
    const numberOfCargoes = cargoesEntry?.value as number;
    if (numberOfCargoes == null) return false;

    const cargoes = stowageDetailsSection['cargoes'] as FormSectionStateArray;

    const invalid = cargoes.some((cargo, index) =>
      Object.values(cargo).some((field) => index < numberOfCargoes && field.status === 'INVALID')
    );

    return !invalid;
  };

  const stowageDetailsValid = isStowageDetailsValid();
  const isCargoDetailsValid = stowageDetailsValid;

  return {
    isStowageDetailsValid: stowageDetailsValid,
    isCargoDetailsValid,
  };
}
